import { useEffect, useState } from "react";

export const HowItWorks = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section id="how-it-works" className="mb-24 pt-16 -mt-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold mb-4">How Igbanwo Works</h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Our platform makes it easy to barter your homegrown bounty with
          neighbours and build a sustainable local food system.
        </p>
      </div>

      <div
        className={`grid md:grid-cols-3 gap-8 transition-all duration-1000 transform ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
        }`}
      >
        <div className="bg-white p-6 rounded-xl border border-border/60 shadow-sm">
          <div className="w-12 h-12 bg-igbanwo-mint/10 rounded-full flex items-center justify-center mb-4">
            <span className="text-xl font-bold text-igbanwo-mint">1</span>
          </div>
          <h3 className="text-xl font-semibold mb-2">List Your Harvest</h3>
          <p className="text-muted-foreground">
            Create a listing for your extra produce, eggs, honey, or homemade
            goods. Add photos and descriptions.
          </p>
        </div>
        <div className="bg-white p-6 rounded-xl border border-border/60 shadow-sm">
          <div className="w-12 h-12 bg-igbanwo-mint/10 rounded-full flex items-center justify-center mb-4">
            <span className="text-xl font-bold text-igbanwo-mint">2</span>
          </div>
          <h3 className="text-xl font-semibold mb-2">Connect With Neighbours</h3>
          <p className="text-muted-foreground">
            Browse listings in your area and message other growers to arrange
            trades or exchanges.
          </p>
        </div>
        <div className="bg-white p-6 rounded-xl border border-border/60 shadow-sm">
          <div className="w-12 h-12 bg-igbanwo-mint/10 rounded-full flex items-center justify-center mb-4">
            <span className="text-xl font-bold text-igbanwo-mint">3</span>
          </div>
          <h3 className="text-xl font-semibold mb-2">Trade Locally</h3>
          <p className="text-muted-foreground">
            Meet up to exchange food items, build community connections, and
            enjoy fresh local produce.
          </p>
        </div>
      </div>
    </section>
  );
};
